module.exports = __webpack_public_path__ + "static/media/B.184c2bba.png";